import React from 'react';
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  makeStyles,
  Theme,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { IReduxState } from '../../types';
import { themeColors } from '../../constants/theme';
import { EMPTY_VALUE, toDate } from '../../helpers/utils';

const useStyles = makeStyles((theme: Theme) => ({
  tableHeadCell: {
    backgroundColor: '#555',
    color: '#fff',
    borderColor: themeColors.yellow,
  },
  tableCell: {
    color: '#fff',
    borderColor: themeColors.yellow,
  },
}));

/**
 * Reiter "Bestätigte Services": zeigt die Historie der quittierten Services
 * einer Maschine. Die Daten stammen aus MaintenanceInfo und werden bereits
 * serverseitig absteigend nach Stundenstand sortiert geliefert.
 */
export default function MachineServiceTab() {
  const classes = useStyles();
  const { t } = useTranslation();

  const machine = useSelector((state: IReduxState) => state.machineDetails.machine);
  const confirmedServices = machine.maintenanceInfo?.machineServices ?? [];

  if (confirmedServices.length === 0) {
    return (
      <Typography variant="body2" color="textSecondary">
        {t('machine.serviceHistoryEmpty')}
      </Typography>
    );
  }

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell className={classes.tableHeadCell}>
            {t('machine.serviceHistoryDate')}
          </TableCell>
          <TableCell className={classes.tableHeadCell}>
            {t('machine.serviceName')}
          </TableCell>
          <TableCell className={classes.tableHeadCell}>
            {t('machine.serviceHistoryDueAt')}
          </TableCell>
          <TableCell className={classes.tableHeadCell}>
            {t('machine.serviceHistoryHours')}
          </TableCell>
          <TableCell className={classes.tableHeadCell}>
            {t('machine.serviceHistoryConfirmedBy')}
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {confirmedServices.map((service) => (
          <TableRow key={service.id}>
            <TableCell className={classes.tableCell}>
                {toDate(service.serviceDate)}
            </TableCell>
            <TableCell className={classes.tableCell}>{service.serviceName}</TableCell>
            <TableCell className={classes.tableCell}>{service.serviceHours}</TableCell>
            <TableCell className={classes.tableCell}>{service.workingHours ?? EMPTY_VALUE}</TableCell>
            <TableCell className={classes.tableCell}>
              {service.technicianName ?? EMPTY_VALUE}
              {service.technicianEmail ? ` (${service.technicianEmail})` : ''}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}